module.exports = __webpack_public_path__ + "img/72000.b2f4a558.jpg";